import staticEndPoints from "./staticEndpoints";
import apiEndpoints from "./apiEndpoints";

const apis = {
  ...staticEndPoints,
  ...apiEndpoints,
};
export default apis;
